import { render, staticRenderFns } from "./IndicatorChangesPanel.vue?vue&type=template&id=45230dec&scoped=true"
import script from "./IndicatorChangesPanel.vue?vue&type=script&lang=js"
export * from "./IndicatorChangesPanel.vue?vue&type=script&lang=js"
import style0 from "./IndicatorChangesPanel.vue?vue&type=style&index=0&id=45230dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45230dec",
  null
  
)

export default component.exports